// 事前審査開始メール送信完了
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Heading from '../../molecules/Heading';
import Block from '../../molecules/Block';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';
import { isBrowserIe } from '../../BrowserJudgment';

const MailSendComplete = () => {
  const [complete_body, setCompleteBody] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();

    // 本文を取得する
    const node = document.getElementById('mail-send-complete-body');
    setCompleteBody(node?.innerHTML as string);
  }, []);

  /**
   * dangerouslySetInnerHTMLにセットするためのオブジェクト
   * @returns object
   */
  const createCompleteBody = () => {
    return { __html: complete_body };
  };

  // 戻るボタン押下時の処理
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('mail-send-complete');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <>
      <Heading label="事前審査申込" size="l" />
      <Block
        label={'メールアドレス確認'}
        content={
          <>
            <div dangerouslySetInnerHTML={createCompleteBody()}></div>
            <div className="content-box">
              <TransitionButton label="戻る" handleClick={backTransition} />
            </div>
          </>
        }
      />
    </>
  );
};

if (document.getElementById('mail-send-complete')) {
  render(<MailSendComplete />, document.getElementById('mail-send-complete'));
}
